import { Group, Text, Title } from "@mantine/core";

import { IPageHeaderProps } from "./page-header.models";

export const PageHeader = ({
  title,
  description,
  actions,
}: IPageHeaderProps) => (
  <Group justify="space-between" align="flex-start" gap="md" mb="lg">
    <div>
      <Title order={1} size="h2">
        {title}
      </Title>
      {description && (
        <Text size="sm" c="dimmed" mt={4}>
          {description}
        </Text>
      )}
    </div>
    {actions}
  </Group>
);
